import { render, staticRenderFns } from "./Create-Ticket-Reminder.vue?vue&type=template&id=f085d9f0"
import script from "./Create-Ticket-Reminder.vue?vue&type=script&lang=js"
export * from "./Create-Ticket-Reminder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports